import { ReactElement } from 'react';
import { FormListFieldData, FormListOperation } from 'antd/es/form';
import { styled } from 'styled-components';
import Row from './Row';
import { BulkCreateAdvisorsResponse } from '@minutes-system/backend/src/api/advisors/schema';

const RowStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

interface Props {
  fields: FormListFieldData[];
  onRemove: FormListOperation['remove'];
  minRows: number;
  results: BulkCreateAdvisorsResponse | null;
}

const TableRows = ({ fields, onRemove, minRows, results }: Props): ReactElement => (
  <RowStack>
    {fields.map(field => {
      const matchedResult = results?.results.find(r => r.rowKey === field.key);
      return (
        <Row
          key={field.key}
          fieldName={field.name}
          rowKey={field.key}
          onRemove={() => {
            onRemove(field.name);
          }}
          canRemove={fields.length > minRows}
          result={matchedResult}
        />
      );
    })}
  </RowStack>
);

export default TableRows;
